export { default } from './CircleWithHole'
